<template>
    <div id="dislay">
        <!--    <div v-if="!signedIn">-->
        <!--        <amplify-authenticator></amplify-authenticator>-->
        <!--    </div>-->
        <div v-if="signedIn">
            <!--        <amplify-sign-out class="signout"></amplify-sign-out>-->
            <div>
                <amplify-photo-picker
                        v-bind:photoPickerConfig="photoPickerConfig"
                ></amplify-photo-picker>
                <amplify-s3-album path="dfs_art/"></amplify-s3-album>
            </div>

            <v-form id="artwork">
                <div class="v-text-field">
                    <v-text-field label="Title" v-model="title"></v-text-field>
                </div>
                <div class="v-text-field">
                    <v-text-field label="Description" v-model="description"></v-text-field>
                </div>
                <div class="v-text-field">
                    <v-text-field label="Year" v-model="year"></v-text-field>
                </div>
                <div class="v-text-field">
                    <label for="file_name">File name</label>
                    <br/><input type="text" id="file_name" v-model="file_name">

                </div>
                <div class="v-text-field">
                    <label for="art_height">Height</label>
                    <br/><input type="text" id="art_height" v-model="art_height" number>
                </div>
                <div class="v-text-field">
                    <label for="art_width">Width</label>
                    <br/><input type="text" id="art_width" v-model="art_width" number>

                </div>
                <div>
                    <v-radio-group v-model="art_media" :mandatory="true" label="Art media">
                        <v-radio label="Canvas" value="Canvas"></v-radio>
                        <v-radio label="Masonite" value="Masonite"></v-radio>
                        <v-radio label="Illustration Board" value="Illustration board"></v-radio>
                    </v-radio-group>
                </div>
                <div class="v-text-field">
                    <label for="type">Type</label>
                    <br/><input type="text" id="type" v-model="type">

                </div>
                <div class="v-text-field">
                    <label for="catalog">Catalog</label>
                    <br/><input type="text" id="catalog" v-model="catalog">

                </div>
                <div class="v-text-field">
                    <label for="owner">Owner</label>
                    <br/><input type="text" id="owner" v-model="owner">

                </div>
                <div class="v-text-field">
                    <label class="label" for="memo">Memo</label>
                    <br/><input class="input" type="text" id="memo" v-model="memo">

                </div>
                <div class="submit">
                    <button type="submit" class="button">Submit</button>
                </div>

            </v-form>
        </div>
    </div>
</template>

<script>
    //https://www.youtube.com/watch?v=C7JDwNIAUMk
    //Amplify, auth and upload: https://medium.com/@dabit3/how-to-build-serverless-vue-applications-with-aws-amplify-67d16c79e9d6
    // import { AmplifyEventBus } from 'aws-amplify-vue'

    const photoPickerConfig = {
        path: 'dfs_art/',
    };

    export default {
        name: 'AddDisplay',
        data() {
            return {
                title: '',
                art_height: 0,
                art_width: 0,
                art_media: 'Canvas',
                catalog: '',
                file_name: '',
                memo: '',
                owner: '',
                type: '',
                year: '',
                description: '',

                signedIn: true,
                photoPickerConfig,
                msg: 'Add Artwork'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
